import { Injectable } from '@angular/core';
import { CONFIG } from 'app/core/config';
import { DashboardWidget } from 'app/viewmodels/dashboard/dashboard-widget';
import { WidgetParameter } from 'app/viewmodels/dashboard/widget-parameter';
import { RiskDistributionParameterType } from '../riskdistribution-parameter-type';
import { ValueSource } from './value-source.enum';
import { ValueType } from './value-type.enum';

@Injectable({
  providedIn: 'root',
})
export class WidgetParametersService {
  constructor() {}

  public filterParameters(widgetParameters: WidgetParameter[], valueSource: ValueSource, valueType: ValueType): WidgetParameter[] {
    return widgetParameters.filter(e => e.valueSource === valueSource && e.valueType === valueType);
  }

  public createWidgetParameter(valueSource: ValueSource, valueType: ValueType, widgetId: string, widgetParameterId?: string): WidgetParameter {
    const widgetParameter: WidgetParameter = new WidgetParameter();
    widgetParameter.valueSource = valueSource;
    widgetParameter.valueType = valueType;
    widgetParameter.widgetId = widgetId;
    widgetParameter.widgetParameterId = widgetParameterId;
    widgetParameter.guidValue = CONFIG.constants.emptyGuid;
    widgetParameter.intValue = 0;
    return widgetParameter;
  }

  public setWidgetParameterValue(widgetParameter: WidgetParameter, value: any): void {
    switch (widgetParameter.valueType) {
      case ValueType.Guid:
        widgetParameter.guidValue = value;
        break;
      case ValueType.Int:
        widgetParameter.intValue = value;
        break;
    }
  }

  public getRiskDistributionParameter(dashboardWidget: DashboardWidget): RiskDistributionParameterType {
    if (dashboardWidget && dashboardWidget.widget && dashboardWidget.widget.widgetParameters) {
      const {
        widget: { widgetParameters },
      } = dashboardWidget;
      return this.filterParameters(widgetParameters, ValueSource.RiskDistributionEnum, ValueType.Int).map(e => e.intValue)[0];
    }

    return RiskDistributionParameterType.RiskBand;
  }
}
